import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm$sectionData, _vm$sectionData2, _vm$sectionData3, _vm$sectionData4, _vm$sectionData5, _vm$sectionData6, _vm$sectionData7;
  var _vm = this,
    _c = _vm._self._c;
  return (_vm$sectionData = _vm.sectionData) !== null && _vm$sectionData !== void 0 && _vm$sectionData.products && _vm.sectionData.products.length > 0 ? _c("section", {
    staticClass: "post-section-5"
  }, [_c("span", {
    staticClass: "separator"
  }, [_vm._v("*")]), _c("p", {
    staticClass: "products-section-title"
  }, [_vm._v("Clos & Monopole Premium selects")]), _c("div", {
    staticClass: "products-grid"
  }, [_c("div", {
    staticClass: "product-card"
  }, [_c("img", {
    attrs: {
      src: _vm.urlForImage(_vm.sectionData.products[0].image).width(2000).url()
    }
  }), _c("p", {
    staticClass: "product-name"
  }, [_vm._v(_vm._s((_vm$sectionData2 = _vm.sectionData) === null || _vm$sectionData2 === void 0 || (_vm$sectionData2 = _vm$sectionData2.products[0]) === null || _vm$sectionData2 === void 0 ? void 0 : _vm$sectionData2.title))]), _c("p", {
    staticClass: "product-description"
  }, [_vm._v(_vm._s((_vm$sectionData3 = _vm.sectionData) === null || _vm$sectionData3 === void 0 || (_vm$sectionData3 = _vm$sectionData3.products[0]) === null || _vm$sectionData3 === void 0 ? void 0 : _vm$sectionData3.description))])]), _c("div", {
    staticClass: "product-card"
  }, [_c("img", {
    attrs: {
      src: _vm.urlForImage(_vm.sectionData.products[1].image).width(2000).url()
    }
  }), _c("p", {
    staticClass: "product-name"
  }, [_vm._v(_vm._s((_vm$sectionData4 = _vm.sectionData) === null || _vm$sectionData4 === void 0 || (_vm$sectionData4 = _vm$sectionData4.products[1]) === null || _vm$sectionData4 === void 0 ? void 0 : _vm$sectionData4.title))]), _c("p", {
    staticClass: "product-description"
  }, [_vm._v(_vm._s((_vm$sectionData5 = _vm.sectionData) === null || _vm$sectionData5 === void 0 || (_vm$sectionData5 = _vm$sectionData5.products[1]) === null || _vm$sectionData5 === void 0 ? void 0 : _vm$sectionData5.description))])]), _c("div", {
    staticClass: "product-card"
  }, [_c("img", {
    attrs: {
      src: _vm.urlForImage(_vm.sectionData.products[2].image).width(2000).url()
    }
  }), _c("p", {
    staticClass: "product-name"
  }, [_vm._v(_vm._s((_vm$sectionData6 = _vm.sectionData) === null || _vm$sectionData6 === void 0 || (_vm$sectionData6 = _vm$sectionData6.products[2]) === null || _vm$sectionData6 === void 0 ? void 0 : _vm$sectionData6.title))]), _c("p", {
    staticClass: "product-description"
  }, [_vm._v(_vm._s((_vm$sectionData7 = _vm.sectionData) === null || _vm$sectionData7 === void 0 || (_vm$sectionData7 = _vm$sectionData7.products[2]) === null || _vm$sectionData7 === void 0 ? void 0 : _vm$sectionData7.description))])])])]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };